import ContactMe from "./YogaContactMe";

export default function ContactMePage() {
    return (
        <>
        <div className="h-screen">
            <div className="bg-[#57562A] py-40">
            <div className="text-black bg-[#FFF8F2] rounded-xl pt-20 mx-5 lg:w-[1000px]  flex items-center lg:mx-auto">
        <ContactMe/>
        </div>
        </div></div>
                {/* <div className="h-screen">
            <div className="relative">
            <div className="bg-[#57562A] min-h-[1200px]"></div>

             <div className="absolute top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-2/3 w-full text-center text-white text-2xl md:text-4xl">
                GET IN CONTACT
            </div>
        </div><ContactMe /> */}
        {/* </div> */}


        </>
    )
}
